import PATHS from 'src/router/paths'

const columns = {
  account: [],
  settings: [],

  profile: [
    {
      align: 'start',
      class: 'org-billing-code',
      columnName: 'Billing Code',
      columnValue: (item) => item.billingCode,
      href: (item) => `/internal/organization/${item.billingCode}`,
      isLinkExternal: false,
      key: 'billingCode',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-name',
      columnName: 'Name',
      columnValue: (item) => item.orgName,
      initialSorted: true,
      key: 'orgName',
      sortable: true,
      width: 280,
    },
    {
      align: 'start',
      class: 'org-network-code',
      columnName: 'Network Code',
      columnValue: (item) => item.networkCode,
      isLinkExternal: true,
      initialSorted: true,
      key: 'networkCode',
      linkProperty: 'adServerUrl',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-active',
      columnName: 'Active',
      columnValue: (item) => item.isActive,
      isLinkExternal: false,
      key: 'isActive',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-deleted',
      columnName: 'Deleted',
      columnValue: (item) => item.isDeleted,
      isLinkExternal: false,
      key: 'isDeleted',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-purpose',
      columnName: 'Internal Use Only',
      columnValue: (item) => item.isInternalUseOnly,
      isLinkExternal: false,
      key: 'isInternalUseOnly',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-is-timesheet-enabled',
      columnName: 'Timesheets',
      columnValue: (item) => item.hasTimesheetReport,
      initialSorted: true,
      key: 'hasTimesheetReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-discrepancy',
      columnName: 'Discrepancy',
      columnValue: (item) => item.hasDiscrepancyReport,
      href: (item) => {
        const { hasDiscrepancy, publisherId } = item

        return hasDiscrepancy ? `/reports/${PATHS.REPORTS.DISCREPANCY}/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasDiscrepancyReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-pacing',
      columnName: 'Pacing',
      columnValue: (item) => item.hasPacingReport,
      href: (item) => {
        const { hasPacing, publisherId } = item

        return hasPacing ? `/reports/${PATHS.REPORTS.PACING}/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasPacingReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'AdX Health',
      columnValue: (item) => item.hasHealthAdxReport,
      href: (item) => {
        const { hasHealthAdx, publisherId } = item

        if (hasHealthAdx) return `/reports/${PATHS.REPORTS.ADX_HEALTH}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthAdxReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Network Health',
      columnValue: (item) => item.hasHealthNetworkReport,
      href: (item) => {
        const { hasHealthNetwork, publisherId } = item

        if (hasHealthNetwork) return `/reports/${PATHS.REPORTS.NETWORK_HEALTH}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthNetworkReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Yield Partner',
      columnValue: (item) => item.hasYieldPartnerReport,
      href: (item) => {
        const { hasYieldPartner, publisherId } = item

        if (hasYieldPartner) return `/reports/${PATHS.REPORTS.YIELD_PARTNER}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasYieldPartnerReport',
      sortable: true,
      width: 150,
    },
  ],
}

export default columns
